import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Visit } from "@/services/api/trackReports";

type Separation = "date" | "reference_point";
type Filter = "vehicle" | "reference_point";

interface VisitsReportTableProps {
  visitsData: {
    title: string;
    visits: Visit[];
  }[];
  separation: Separation;
  filter: Filter;
}
const VisitsReportTable = ({
  visitsData,
  separation,
  filter,
}: VisitsReportTableProps) => {
  return (
    <div className="flex flex-col gap-5 bg-white dark:bg-slate-800 p-4 rounded-lg shadow-xs hover:shadow-md border border-slate-100 dark:border-slate-700">
      <h1 className="text-3xl text-center font-bold">Visitas</h1>
      {visitsData.map((data) => {
        if (filter === "vehicle") {
          return (
            <div key={data.title}>
              <Table className="w-full mb-5">
                <TableHeader>
                  <TableRow>
                    <TableHead colSpan={5} className="text-center">
                      {data.title}
                    </TableHead>
                  </TableRow>
                  <TableRow>
                    <TableHead className="w-1/3">
                      {separation === "date" ? "Ponto de Referência" : "Data"}
                    </TableHead>
                    <TableHead className="text-center">Entrada</TableHead>
                    <TableHead className="text-center">Saída</TableHead>
                    <TableHead className="text-center">Tempo</TableHead>
                    <TableHead className="text-center">Objetivo</TableHead>
                  </TableRow>
                </TableHeader>

                <TableBody>
                  {data.visits.map((visit) => {
                    return (
                      <TableRow
                        key={`${visit.date}-${visit.entrance_hour}`}
                        className="dark:text-white"
                      >
                        <TableCell>
                          {separation === "date"
                            ? visit.reference_point
                            : visit.date}
                        </TableCell>
                        <TableCell className="text-center">
                          {visit.entrance_hour}
                        </TableCell>
                        <TableCell className="text-center">
                          {visit.exit_hour}
                        </TableCell>
                        <TableCell className="text-center">
                          {visit.standing_time}
                        </TableCell>
                        <TableCell className="text-center">
                          {visit.visit_objective_title ?? "-"}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </div>
          );
        } else if (filter === "reference_point") {
          return (
            <div key={data.title}>
              <Table className="w-full mb-5">
                <TableHeader>
                  <TableRow>
                    <TableHead colSpan={6} className="text-center">
                      {data.title}
                    </TableHead>
                  </TableRow>
                  <TableRow>
                    <TableHead className="w-1/3">Veículo</TableHead>
                    <TableHead className="text-center">Entrada</TableHead>
                    <TableHead className="text-center">Saída</TableHead>
                    <TableHead className="text-center">Tempo</TableHead>
                    <TableHead className="text-center">Objetivo</TableHead>
                  </TableRow>
                </TableHeader>

                <TableBody>
                  {data.visits.map((visit) => {
                    return (
                      <TableRow
                        key={`${visit.date}-${visit.entrance_hour}`}
                        className="dark:text-white"
                      >
                        <TableCell>
                          {visit.vehicle_plate} {visit.vehicle_title}
                        </TableCell>
                        <TableCell className="text-center">
                          {visit.entrance_hour}
                        </TableCell>
                        <TableCell className="text-center">
                          {visit.exit_hour}
                        </TableCell>
                        <TableCell className="text-center">
                          {visit.standing_time}
                        </TableCell>
                        <TableCell className="text-center">
                          {visit.visit_objective_title ?? "-"}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </div>
          );
        }
      })}
    </div>
  );
};

export default VisitsReportTable;
